<div class="wrapper">
  <div class="gradient-bar"></div>
  <mat-card>
    <img
      src="../../../assets/images/actabl-blue.png"
      alt="Actabl"
      class="actabl"
    />
    <mat-card-content>
      <h6>
        {{
          'resetPassword.title'
            | translate
              : { actablUnifiedAccount: 'actablUnifiedAccount' | translate }
        }}
      </h6>
      <p>
        {{ 'resetPassword.text' | translate }}
      </p>
      <mat-divider></mat-divider>
      <p class="username">
        <span class="strong">{{ 'pairing.username' | translate }}:</span>
        {{ username }}
      </p>
      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
        <div class="form-row">
          <div class="form-group">
            <label>{{ 'login.password' | translate }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="new-password"
                formControlName="password"
                minlength="8"
                name="password"
                [type]="showPassword ? 'text' : 'password'"
                required
              />
              <mat-icon
                matSuffix
                class="material-icons-outlined"
                (click)="showPassword = !showPassword"
              >
                {{ showPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </mat-form-field>
          </div>
          <div class="form-group">
            <label>{{ 'pairing.confirmPassword' | translate }}</label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="confirm-password"
                formControlName="confirmPassword"
                minlength="8"
                name="confirmPassword"
                [type]="showConfirmPassword ? 'text' : 'password'"
                required
              />
              <mat-icon
                matSuffix
                class="material-icons-outlined"
                (click)="showConfirmPassword = !showConfirmPassword"
              >
                {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div id="password-errors">
          @if ( form['confirmPassword'].invalid &&
          !wasTouched('confirmPassword') && (form['password'].valid ||
          !wasTouched('password')) ) {
          <mat-hint>{{ 'pairing.passwordHelper' | translate }}</mat-hint>
          } @if ( wasTouched('password') &&
          form['password'].errors?.['required'] ) {
          <mat-error>
            {{ 'pairing.create.error.password.empty' | translate }}
          </mat-error>
          } @if ( form['password'].errors?.['minlength'] ||
          form['password'].errors?.['serverError'] ) {
          <mat-error>
            {{ 'pairing.create.error.password.short' | translate }}
          </mat-error>
          } @if ( form['password'].errors?.['pattern'] ||
          form['password'].errors?.['serverError'] ) {
          <mat-error>
            {{ 'pairing.create.error.password.format' | translate }}
          </mat-error>
          } @if (form['password'].errors?.['reusedPassword']) {
          <mat-error>
            {{ 'resetPassword.reusedPassword' | translate }}
          </mat-error>
          } @if ( wasTouched('confirmPassword') &&
          form['confirmPassword'].errors?.['required'] ) {
          <mat-error>
            {{ 'pairing.create.error.password.notConfirmed' | translate }}
          </mat-error>
          } @if (form['confirmPassword'].errors?.['matching']) {
          <mat-error>
            {{ 'pairing.create.error.password.match' | translate }}
          </mat-error>
          }
        </div>
        <button
          class="submit-button"
          color="primary"
          type="submit"
          mat-flat-button
          [disabled]="!token || resetForm.invalid"
        >
          {{ 'resetPassword.button' | translate }}
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
